import pipe from '../utils/pipe';
import jwt from '../utils/jwt';
import { get, set, del } from '../utils/storage';
import { VERSION as SECURITY_VERSION } from '../config/security';
import { getRoles } from '../providers/redux/user';

export const USER = 'user';
export const BEARER = 'bearer';

export const storeUser = token => pipe(token, set(BEARER), jwt, set(USER));
export const getUserbyToken = (tk) => jwt(tk);
export const roles = props => getRoles(getUser()).find(x => x === props);

export const getUser = get(USER);
export const removeUser = del(USER);
export const getBearer = get(BEARER);
export const removeBearer = del(BEARER);

export const ROLE_PRIME_PLUS = 'licenca_de_uso_software_lira_log_perfil.cadastro.prime.plus';
export const ROLE_PRIME_QUERY = 'licenca_de_uso_software_lira_log_perfil.cadastro.prime';

export const hasRoles = (...roles) => {
  // By the time of this writing, Security V1 switch `roles` to `scopes` key.
  // This is fixed in Security V2.
  const realRoles = SECURITY_VERSION === 1 ? 'scopes' : 'roles';

  const user = getUser();
  const userRoles = user[realRoles].split(' ');

  return roles.every(role => userRoles.includes(role));
};
